const statData = {
  HP: [
    100,
    500,
    526,
    552,
    578,
    605,
    631,
    657,
    684,
    710,
    736,
    763,
    789,
    815,
    842,
    868,
    894,
    921,
    947,
    973,
    1000,
    1020,
    1040,
    1060,
    1080,
    1100,
    1120,
    1140,
    1160,
    1180,
    1200,
    1220,
    1240,
    1260,
    1280,
    1300,
    1320,
    1340,
    1360,
    1380,
    1400,
    1420,
    1440,
    1460,
    1480,
    1500,
    1520,
    1540,
    1560,
    1580,
    1600,
    1620,
    1640,
    1660,
    1680,
    1700,
    1720,
    1740,
    1760,
    1780,
    1800,
    1805,
    1810,
    1815,
    1820,
    1825,
    1830,
    1835,
    1841,
    1846,
    1851,
    1856,
    1861,
    1866,
    1871,
    1876,
    1882,
    1887,
    1892,
    1897,
    1902,
    1907,
    1912,
    1917,
    1923,
    1928,
    1933,
    1938,
    1943,
    1948,
    1953,
    1958,
    1964,
    1969,
    1974,
    1979,
    1984,
    1989,
    1994,
    2000,
  ],
  FP: [
    500,
    500,
    526,
    552,
    578,
    605,
    631,
    657,
    684,
    710,
    736,
    763,
    789,
    815,
    842,
    868,
    894,
    921,
    947,
    973,
    1000,
    1020,
    1040,
    1060,
    1080,
    1100,
    1120,
    1140,
    1160,
    1180,
    1200,
    1220,
    1240,
    1260,
    1280,
    1300,
    1320,
    1340,
    1360,
    1380,
    1400,
    1420,
    1440,
    1460,
    1480,
    1500,
    1520,
    1540,
    1560,
    1580,
    1600,
    1620,
    1640,
    1660,
    1680,
    1700,
    1720,
    1740,
    1760,
    1780,
    1800,
    1805,
    1810,
    1815,
    1820,
    1825,
    1830,
    1835,
    1841,
    1846,
    1851,
    1856,
    1861,
    1866,
    1871,
    1876,
    1882,
    1887,
    1892,
    1897,
    1902,
    1907,
    1912,
    1917,
    1923,
    1928,
    1933,
    1938,
    1943,
    1948,
    1953,
    1958,
    1964,
    1969,
    1974,
    1979,
    1984,
    1989,
    1994,
    2000,
  ],
  Slots: [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    7,
    7,
    7,
    7,
    7,
    7,
    7,
    7,
    7,
    7,
    8,
    8,
    8,
    8,
    8,
    8,
    8,
    8,
    8,
    8,
    8,
    8,
    8,
    8,
    8,
    8,
    8,
    8,
    8,
    8,
    9,
    9,
    9,
    9,
    9,
    9,
    9,
    9,
    9,
    9,
    9,
    9,
    9,
    9,
    9,
    9,
    9,
    9,
    9,
    10,
  ],
  load: [
    40,
    41,
    42,
    43,
    44,
    45,
    46,
    47,
    48,
    49,
    50,
    51,
    52,
    53,
    54,
    55,
    56,
    57,
    58,
    59,
    60,
    61,
    62,
    63,
    64,
    65,
    66,
    67,
    68,
    69,
    70,
    71,
    72,
    73,
    74,
    75,
    76,
    77,
    78,
    79,
    80,
    81,
    82,
    83,
    84,
    85,
    86,
    87,
    88,
    89,
    90,
    91,
    92,
    93,
    94,
    95,
    96,
    97,
    98,
    99,
    100,
    101,
    102,
    103,
    104,
    105,
    106,
    107,
    108,
    109,
    110,
    111,
    112,
    113,
    114,
    115,
    116,
    117,
    118,
    119,
    120,
    121,
    122,
    123,
    124,
    125,
    126,
    127,
    128,
    129,
    130,
    131,
    132,
    133,
    134,
    135,
    136,
    137,
    138,
    139,
  ],
  stamina: [
    83,
    83,
    84,
    85,
    86,
    87,
    88,
    89,
    91,
    92,
    94,
    95,
    97,
    98,
    100,
    102,
    104,
    106,
    108,
    110,
    112,
    114,
    116,
    118,
    120,
    122,
    125,
    127,
    129,
    132,
    134,
    136,
    139,
    141,
    144,
    146,
    149,
    152,
    154,
    157,
    160,
    160,
    160,
    160,
    160,
    160,
    161,
    161,
    161,
    161,
    161,
    161,
    162,
    162,
    162,
    162,
    162,
    162,
    163,
    163,
    163,
    163,
    163,
    163,
    164,
    164,
    164,
    164,
    164,
    164,
    165,
    165,
    165,
    165,
    165,
    165,
    166,
    166,
    166,
    166,
    166,
    166,
    167,
    167,
    167,
    167,
    167,
    167,
    168,
    168,
    168,
    168,
    168,
    168,
    169,
    169,
    169,
    169,
    169,
    170,
  ],
};

export default statData;
